// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"383ca6a0","703":"1a08a445"}[chunkId] + ".chunk.js";
};